import React, { useState, useEffect } from "react";
import AvailabilityManager from "./ManageAvailability";
import UserSchedule from "./ManageSchedule";

export function UserAvailability({user}) {
    const [userId, setUserId] = useState(null);
    const [activeSection, setActiveSection] = useState("schedule"); // Default section
    const [scheduleKey, setScheduleKey] = useState(0); // 🔹 Key to force re-mount of Schedule
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
            setUserId(user._id);
    }, [user]);

    // 🔹 Function to switch tabs and trigger a re-fetch
    const handleTabSwitch = (section) => {
        setActiveSection(section);
        if (section === "schedule") {
            setScheduleKey(prevKey => prevKey + 1);
            // Set refresh to true and then back to false after a short delay
            setRefresh(true);
            setTimeout(() => setRefresh(false), 100);
        }
    };
    

    return (
        <div className="p-2 mb-3 bg-white min-vh-100 d-flex flex-column">
            {/* Tabs */}
            <div className="d-flex justify-content-start pb-2 mb-3">
                <h5
                    className={`fw-normal me-3 ${
                        activeSection === "schedule"
                            ? "text-primary fw-normal"
                            : "text-secondary fw-light"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleTabSwitch("schedule")} // 🔹 Call the function
                >
                    Schedule
                </h5>
                <span className="text-secondary mx-3 pb-1">|</span>
                <h5
                    className={`fw-normal ${
                        activeSection === "availability"
                            ? "text-primary fw-normal"
                            : "text-secondary fw-light"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleTabSwitch("availability")} // 🔹 Call the function
                >
                    Availability
                </h5>
            </div>

            {/* Tab Content - Wrapped in flex-grow-1 & overflow-auto */}
            <div className="flex-grow-1 overflow-auto">
            {activeSection === "schedule" && <UserSchedule key={scheduleKey} userId={userId} refresh={refresh} />}

                {activeSection === "availability" && userId && <AvailabilityManager userId={userId} />}
            </div>
        </div>
    );
}
